// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"cd30f967","179":"3e36c935","279":"00afabb6","354":"4ef7c0f6","526":"4f779b66","536":"cf8ba5d9","804":"c00712b7","898":"5c8818bb","927":"5b27f0cc"}[chunkId] + ".chunk.js";
};